import { Model } from '@/clients/http'

import { ChatHttpParams, ChatResponses } from '@/types'

export class ChatModel extends Model {
  public static readonly correlations = {
    GET_SESSIONS: 'GET_CHAT_SESSIONS',
    GET_TRANSCRIPT: 'GET_CHAT_TRANSCRIPT',
  }

  public static readonly endpoints = {
    getSessions: (props?: ChatHttpParams.GetSessions) =>
      this.createEndpoint({
        url: '/api/backoffice/chat',
        query: props?.query,
      }),

    getTranscript: (props?: ChatHttpParams.GetTranscript) =>
      this.createEndpoint({
        url: '/api/backoffice/chat/:sessionId',
        params: props?.params,
        query: props?.query,
      }),
  }

  /**
   * Get a paginated list of chat sessions
   */
  public static readonly getSessions = async (props?: ChatHttpParams.GetSessions) => {
    return this.createHttpRequest<ChatResponses.GetSessions, ChatResponses.GetSessionsError>({
      correlationKey: this.correlations.GET_SESSIONS,
      payload: {
        method: 'get',
        url: this.endpoints.getSessions(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }

  /**
   * Get the full message transcript for one chat session
   */
  public static readonly getTranscript = async (props: ChatHttpParams.GetTranscript) => {
    return this.createHttpRequest<ChatResponses.GetTranscript, ChatResponses.GetTranscriptError>({
      correlationKey: this.correlations.GET_TRANSCRIPT,
      payload: {
        method: 'get',
        url: this.endpoints.getTranscript(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
